import { SyntheticEvent } from 'react'

import BasicTabs from 'components/tabs/basic-tabs/basic-tabs.component'
import TabPanel from 'components/tabs/tab-panel/tab-panel.component'

import { invoiceTabs } from '../invoice.constants'
import InvoiceListContainer from './invoice-list-container/invoice-list-container'

interface InvoiceSelectionProps {
  tabsValue: number
  handleChange: (event: SyntheticEvent, newValue: number) => void
}

const InvoiceSelection = ({
  tabsValue,
  handleChange,
}: InvoiceSelectionProps) => {
  return (
    <BasicTabs
      tabs={invoiceTabs}
      value={tabsValue}
      handleChange={handleChange}
      scrollableContent
    >
      <TabPanel value={tabsValue} index={0}>
        <InvoiceListContainer invoiceType="TO_DELIVER" />
      </TabPanel>
      <TabPanel value={tabsValue} index={1}>
        <InvoiceListContainer invoiceType="TO_INVOICE" />
      </TabPanel>
      <TabPanel value={tabsValue} index={2}>
        <InvoiceListContainer invoiceType="NOT_PAID" />
      </TabPanel>
      <TabPanel value={tabsValue} index={3}>
        <InvoiceListContainer invoiceType="PAID" />
      </TabPanel>
    </BasicTabs>
  )
}

export default InvoiceSelection
